import { whiteColor } from 'assets/jss/material-dashboard-pro-react';
const customFilterStyle = (theme) => ({
	checkbox: {
		'& svg': {
			width: 16,
			height: 16,
		},
	},
	checkboxUnchecked: {
		'& svg': {
			padding: 7,
		},
	},
	accordionTitle: {
		marginLeft: -8,
	},
	accordionTitleContainer: {
		height: 40,
		borderBottom: 'none',
		borderTopLeftRadius: 4,
		borderTopRightRadius: 4,
	},
	accordionElementContainer: {
		borderBottomLeftRadius: 4,
		borderBottomRightRadius: 4,
		boxShadow: '0 8px 12px -6px rgba(0, 0, 0, 0.5)',
		position: 'absolute',
		backgroundColor: whiteColor,
		zIndex: 500,
		[theme.breakpoints.down('sm')]: {
			position: 'static',
		},
	},
	accordionElement: {
		display: 'flex',
	},
	accordionElementLabel: {
		width: '100%',
		margin: 'auto',
		marginLeft: 16,
		cursor: 'pointer',
		textOverflow: 'ellipsis',
		// overflow: 'hidden',
		whiteSpace: 'nowrap',
	},
	accordionRefresh: {
		width: '100%',
		margin: 0,
	},
	radio: {
		'& svg': {
			height: 16,
			width: 16,
		},
		width: 40,
		height: 40,
		marginRight: 12,
	},
	radioUnchecked: {
		'& svg': {
			padding: 6,
		},
	},
	showElement: {
		width: `calc(100% - 32px) !important`,
		marginTop: 0,
		marginBottom: 0,
		'& MuiFormControl-root': {
			paddingTop: 0,
		},
	},
	filtersWrapper: {
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-start',
		marginBottom: 16,
		flexWrap: 'wrap',
	},
});

export default customFilterStyle;
